<lib-page-layout>
  <lib-title-navbar pageHeader title="News"></lib-title-navbar>

  <div>
    <ng-template #dynamicContainer></ng-template>
  </div>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
